import React from 'react'
import FloatingActionButton from 'material-ui-legacy/FloatingActionButton'
import ContentAdd from 'material-ui-legacy/svg-icons/content/add'

const BigAddButton = (props) => (
  <FloatingActionButton {...props}>
    <ContentAdd />
  </FloatingActionButton>
)

export default BigAddButton



// WEBPACK FOOTER //
// ./src/components/UI/BigAddButton.jsx